// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"651655f4","787":"737d3cc7","934":"f9f44b41"}[chunkId] + ".chunk.js";
};